// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2UIMY","footer":"ModalFilter_footer__3pn61"};